const Loading = () => {
    return (
        <>
            <div className="bgLoad">
                <div className="loader"></div>
            </div>
        </>
    )
}

export default Loading